import { render, staticRenderFns } from "./activeRate.vue?vue&type=template&id=2f285482&"
import script from "./activeRate.vue?vue&type=script&lang=js&"
export * from "./activeRate.vue?vue&type=script&lang=js&"
import style0 from "./activeRate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports